<template>
    <div class="country-sg" :class="$x.nsAddressForm">
        <VTextField
            v-model="address.address1"
            name="address1"
            maxlength="40"
            required
            validate-on-blur
            :label="t.address1Label"
            class="flex-column"
            :class="$x.region"
            :rules="address1Rules"
            @blur="onBlur"
            @input="addressUpdated"
        ></VTextField>
        <VTextField
            v-model="address.address2"
            name="address2"
            maxlength="35"
            validate-on-blur
            class="flex-column"
            :aria-label="t.address2Label"
            :rules="address2Rules"
            @blur="onBlur"
            @input="addressUpdated"
        >
            <template #label>
                {{ t.address2Label }}
                <span class="optional"> {{ t.optional }} </span>
            </template>
        </VTextField>
        <div :class="$x.dualColumn">
            <VTextField
                v-model="address.city"
                name="city"
                maxlength="20"
                readonly
                :label="t.cityLabel"
                class="flex-column"
                :class="$x.firstCol"
                disabled
            ></VTextField>
            <VTextField
                v-model="address.postalCode"
                name="postalCode"
                maxlength="10"
                required
                validate-on-blur
                :label="t.postalCodeLabel"
                class="flex-column"
                :class="$x.region"
                :rules="postalCodeRules"
                @blur="onBlur"
                @input="addressUpdated"
            ></VTextField>
        </div>
        <VTextField
            v-if="includeEmail"
            v-model="address.email"
            name="email"
            maxlength="50"
            :required="emailRequired"
            validate-on-blur
            :label="t.emailLabel"
            class="flex-column"
            :rules="emailRules"
            @input="addressUpdated"
            @blur="onBlur"
        ></VTextField>
    </div>
</template>

<script>
import { VTextField } from 'vuetify/lib';
import ADDRESS_MIXIN from '../addressMixin';
// Most of the logic for this component is in the mixin
import TRANSLATIONS from './translations';

export default {
    name: 'NsAddressSg',
    components: {
        VTextField,
    },
    mixins: [ADDRESS_MIXIN],

    mounted() {
        this.address.country = 'SG';
        this.address.region = 'SG';
        this.address.city = 'Singapore';
        if (TRANSLATIONS[this.lang]) {
            this.t = TRANSLATIONS[this.lang];
        } else {
            // If the language isn't available then get the first language in translations file
            this.t = TRANSLATIONS[Object.keys(TRANSLATIONS)[0]];
        }
        this.$emit('new-address-in-form');
    },
    methods: {},
};
</script>

<style lang="scss" module="$x">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

::v-deep *:not(.v-icon) {
  font-family: map.get(typographyVariables.$typography, font-family-primary);
}

.nsAddressForm {
  .dualColumn {
    display: flex;
    align-content: space-between;
    .firstCol {
      margin-right: 20px;
    }
    .region {
      width: 70px;
    }
  }
}
</style>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
$color-eyore: map.get(colors.$baseColors, eyore);

.optional {
  color: $color-eyore;
}
</style>
